import {
  SchemaValidationErrorLabel,
  shortDisplayTextForSchemaValidationErrorLabel,
} from 'schemas/SchemaValidationConstants';
import {OptionData} from 'ui-library/menus/MenuConstants';

export function getSchemaValidationErrorLabelMenuOptionDatas(): Promise<Array<OptionData>> {
  const errorLabels = [
    SchemaValidationErrorLabel.CONSTRAINT_VIOLATION,
    SchemaValidationErrorLabel.CONFIGURABLE_VALIDATION_RULE_FAILURE,
    SchemaValidationErrorLabel.INVALID_LINK,
    SchemaValidationErrorLabel.INVALID_MULTIPLE_LINK,
    SchemaValidationErrorLabel.INVALID_VALUE,
    SchemaValidationErrorLabel.MISSING_REQUIRED,
    SchemaValidationErrorLabel.OTHER,
  ];

  return Promise.resolve(
    errorLabels.map((errorLabel) => ({
      value: errorLabel,
      name: shortDisplayTextForSchemaValidationErrorLabel(errorLabel),
    }))
  );
}
